import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { Segment, VerticalSpacer } from './../core/core';
import PrimaryButton from './../components/PrimaryButton/PrimaryButton';
import moodboardScreenshot from '../images/example-middleSchool-moodboard-report.png';
import styles from './MarketingMoodboardMiddleSchool.module.scss';
import utilityStyles from './../SCSS/common/utilityStyles.module.scss';
import segmentStyles from './../SCSS/Segment.module.scss';

const MarketingMoodboardMiddleSchool = () => {
  const history = useHistory();
  return (
    <div className={`${styles.marketingMoodboardContainer} ${utilityStyles.clearfix}`}>
      <VerticalSpacer ems={2} />
      <Segment className={utilityStyles.line}>
        <div className={segmentStyles.moduleTitle}>Moodboard Report Example</div>
      </Segment>
      <Segment className={utilityStyles.line}>
        <div className={styles.marketingCopy}>
          <p>
            On our student platform, students are encouraged to do a daily feelings check-in by selecting an emotion
            from our feelings check-in wheel, providing teachers with a heatmap of student sentiment.
          </p>
          <div className='ctaButton'>
            <PrimaryButton onClick={() => history.push('/features')}>Upgrade Now</PrimaryButton>
          </div>
        </div>
        <img
          alt='Screenshot'
          className={cx(utilityStyles.marketingScreenshot, styles.marketingImg)}
          src={moodboardScreenshot}
        />
      </Segment>
    </div>
  );
};

export default MarketingMoodboardMiddleSchool;
